import React from 'react';
import { useCart } from '../context/CartContext';
export function SkinCare() {
  const {
    addToCart
  } = useCart();
  return <div className="bg-white min-h-screen pt-32 pb-20 px-6" data-id="element-814">
      <div className="max-w-[1800px] mx-auto" data-id="element-815">
        <header className="mb-20 text-center" data-id="element-816">
          <span className="text-xs md:text-sm font-display font-bold uppercase tracking-[0.3em] md:tracking-[0.5em] mb-4 block text-black/40" data-id="element-817">
            Natural Radiance
          </span>
          <h1 className="text-xl sm:text-4xl md:text-6xl font-display font-bold tracking-[0.05em] md:tracking-[0.2em] uppercase mb-6" data-id="element-818">
            Coquette Skin Care
          </h1>
          <p className="max-w-xl mx-auto text-sm md:text-base font-light tracking-widest text-black/60 leading-relaxed uppercase px-4 md:px-0" data-id="element-819">
            Organic, botanical-based skin care inspired by traditional African
            beauty rituals.
          </p>
        </header>
        <div className="max-w-4xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-16 items-center" data-id="element-820">
          <div className="aspect-square bg-grey-divider overflow-hidden" data-id="element-821">
            <img src="https://images.unsplash.com/photo-1556228720-195a672e8a03?auto=format&fit=crop&q=80&w=800" className="w-full h-full object-cover" alt="Skin Care" data-id="element-822" />
          </div>
          <div className="space-y-6" data-id="element-823">
            <h2 className="text-xl sm:text-2xl md:text-4xl font-display font-bold tracking-widest uppercase" data-id="element-824">
              The Glow Serum
            </h2>
            <p className="text-sm md:text-base font-light tracking-widest text-black/70 leading-relaxed uppercase" data-id="element-825">
              Infused with Baobab oil and Shea butter for deep nourishment and a
              natural, healthy glow.
            </p>
            <button onClick={() => addToCart({
            id: 'skincare-glow-serum',
            name: 'The Glow Serum',
            price: '$48.00',
            image: 'https://images.unsplash.com/photo-1556228720-195a672e8a03?auto=format&fit=crop&q=80&w=800',
            quantity: 1,
            size: '50ml'
          })} className="border border-black px-10 py-4 text-xs font-display uppercase tracking-widest hover:bg-black hover:text-white transition-all" data-id="element-826">
              Add to Bag
            </button>
          </div>
        </div>
      </div>
    </div>;
}